import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { kidney } from "../../../../constants";


export default function KidneyCard() {
  

return (

    <CardImageMarkers 
    
        image={kidney}
        title="KIDNEY & ELECTROLYTES HEALTH"
        subtitle="Monitor your organ health"
        markersTitle=""
        markers="KREA, eGFR, 
BUN / Harnstoff, 
UA / Harnsäure,
K+, Na+, Cl-, Ca, Phos
Albumin


                "

    />


)
}